import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { GetMenuElements } from '../../lib/Menu';

import MenuItem from './MenuItem/MenuItem';
import './Menu.css';

const Menu = () => {
  const [activeItem, setActiveItem] = useState("");
  const location = useLocation();
  if (location.pathname === '/login') return null;
  return (
    <nav className="Menu">
      {GetMenuElements()
        .map(menuItem =>
          <MenuItem
            menuItem={menuItem}
            key={menuItem.name}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
          />
        )
      }
    </nav>
  )
};

export default Menu;